import { render, staticRenderFns } from "./digitalCourse.vue?vue&type=template&id=1a6c5560"
import script from "./digitalCourse.vue?vue&type=script&lang=js"
export * from "./digitalCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6c5560')) {
      api.createRecord('1a6c5560', component.options)
    } else {
      api.reload('1a6c5560', component.options)
    }
    module.hot.accept("./digitalCourse.vue?vue&type=template&id=1a6c5560", function () {
      api.rerender('1a6c5560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/video/digitalCourse.vue"
export default component.exports